import styled from 'styled-components';

export const AlertPanelWrapper = styled.div`
  margin-top: 5px;
`;

export const PanelRow = styled.div`
  overflow: hidden;
  width: auto;
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;

  > div {
    width: 350px;
    margin: 5px;
    border-radius: 6px;
    flex-grow: 1;
  }
`;

export const HeatMapColors = ['#D0021B', '#FFE600'];
